import styled from 'styled-components';
import { Box } from '@material-ui/core';

export const CheckCard = styled(Box)`
  background-color: rgba(255, 255, 255, 0.1);
`;
